"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalizeControlsHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../../atoms");

var _Modal = require("../../../molecules/Modal");

var _BackButton = require("../../../molecules/Modal/BackButton");

require("./PersonalizeControlsHeader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic, Drew Burnett
 */
var PersonalizeControlsHeader = function PersonalizeControlsHeader(_ref) {
  var className = _ref.className,
      title = _ref.title,
      onBackClick = _ref.onBackClick,
      onCloseClick = _ref.onCloseClick,
      showBackButton = _ref.showBackButton;
  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "personalize-controls-header ".concat(className)
  }, onBackClick && showBackButton && /*#__PURE__*/_react.default.createElement(_BackButton.BackButton, {
    onClick: onBackClick
  }), !onBackClick && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    className: "personalize-controls-header spacer"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: title,
    marginTop: "4",
    marginBottom: "4",
    color: _atoms.Color.Black,
    bold: true,
    type: _atoms.Label.Type.Heading4
  }), /*#__PURE__*/_react.default.createElement(_Modal.CloseButton, {
    onClick: onCloseClick
  }));
};

exports.PersonalizeControlsHeader = PersonalizeControlsHeader;
PersonalizeControlsHeader.defaultProps = {
  onBackClick: null,
  showBackButton: true
};